module.exports = __webpack_public_path__ + "static/media/suba_white_gray.2436f374.png";